import IUserGet from 'api/interfaces/users/IUserGet';

export const convertToFullName = (user: IUserGet): string => {
  if (user != null && user.firstName != null && user.lastName != null) {
    return `${user.firstName} ${user.lastName}`;
  }

  return '';
};
